import { Tag } from 'antd';

const uniqueItemId={
    title: 'uniqueId',
    key: 'uniqueId',
    dataIndex: 'uniqueId',
};
 const permissionColumns=[ {
          title: 'Permissions',
          key: 'permissionNames',
          dataIndex: 'permissionNames',
          render:(permissionNames)=>{
                let locationCount = 0;
                let bluetoothCount = 0;
                let notificationsCount = 0;
                let activityCount = 0;
                let okCount = 0;
            return permissionNames.map((permission) => {
                let permissionText = '';
                let color = ''
                const LOCATION = 'location';
                const BLUETOOTH = 'bluetooth';
                const ACTIVITY = 'activity';
                const NOTIFICATIONS = 'notifications';
                const OK = 'OK';
                if(permission.toLowerCase().includes(LOCATION)){
                    if (locationCount > 0) return ''; 
                    locationCount +=1;
                    permissionText = LOCATION;
                    color = 'red';
                }
                else if(permission.toLowerCase().includes(BLUETOOTH)){
                    if (bluetoothCount > 0) return  ''
                    bluetoothCount +=1;
                    permissionText = BLUETOOTH;
                    color = 'blue';
                }
                else if(permission.toLowerCase().includes(NOTIFICATIONS)){
                    if (notificationsCount > 0) return ''; 
                    notificationsCount +=1;
                    permissionText = NOTIFICATIONS;
                    color = 'purple';
                }
                else if(permission.toLowerCase().includes(ACTIVITY)){
                    if (activityCount > 0) return ''; 
                    activityCount +=1;
                    permissionText = ACTIVITY;
                    color = 'green';
                }
                else if(permission===OK){
                    if (okCount > 0) return ''; 
                    okCount +=1;
                    permissionText = OK;
                    color = 'green';
                }
                return <Tag color={color}>{permissionText}</Tag>
              }
              )
            }
        },
        {
            title: 'dateCreated',
            key: 'dateCreated',
            dataIndex: 'dateCreated',
        },
      
    ];
const defaultColumns =[
         {
                title: 'os',
                key: 'os',
                dataIndex: 'os',
                render: (os)=><Tag color={os==='iOS'? 'red' : 'green'}>{os}</Tag>,
            },
            {
                title: 'osVersion',
                key: 'osVersion',
                dataIndex: 'osVersion',
            },
            {
                title: 'model',
                key: 'model',
                dataIndex: 'model',
            },
         
    ]
export function getPermissionColumns(){
    return  [...defaultColumns, ...permissionColumns] 
}
export function getSearchPermissionColumns(){
    return  [...defaultColumns,...permissionColumns, uniqueItemId] 
}
export function getHeartbeatColumns() { 
    return [...defaultColumns,  uniqueItemId] 
}